var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OptionSelector',{attrs:{"items":[
            {id:1,label:'削除'}
        ]},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }